import React, { useState } from "react";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import { upload_document_v2 } from "./GhareluRenews";
import Documents from "../../../../../components/common/forms/Documents";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import FormNewPayment from "../../../../../components/common/forms/FormNewPayment";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import api from "../../../../../api/api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../../common/AdminSearchCustomer";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";

const NewGhaleru = () => {
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);
  
  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)
  const [uploadProof, setUploadProof] = useState('')

  const handleSub = (data) => {
    data.documents = docsOutput;

    if(user?.user_type === "CL"){
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    }else {
        if(userID !== null){
          data.user = userID
        }
    } 
  
    api
      .post(`services/company/`, data)
      .then((response) => {
        toast.success("Data Registered Successfully")
        
        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.registration_id,
        //   created_by: response.data.registration_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : response.data.company_id,
        //   transaction_type: "credit"
       
        // };

        
        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });
      })
      .catch((error) => {
        // console.log("error", error);
        toast.error("Something went wrong")
      });



  };


  let data_v2 = [];
  upload_document_v2.map((item, i) => {
    data_v2.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <form>
       <div className="mt-3">
          {

           (user?.user_type === "ST" || user?.user_type === "AD")
            && <AdminSearchCustomer 
             setUserId={setUserId}
            /> 
          }
         </div>
      {/* new company for 3 months */}
      <div className="mt-4">
        <div className="border-2 border-primary-blue ">
        <div className="flex-col font-Laila flex md:flex-row flex-wrap">
          <div className="flex flex-1  border-b md:border-r border-primary-blue items-center m-0 px-2 border-primary-blue">
            <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
              कम्पनी नाम :
            </label>
            <input
              type="text"
              placeholder=" "
              {...register("company_name", { required: false })}
              //   name="company_name"

              className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
            />
          </div>
          <div className="flex flex-1 flex-wrap w-fit border-b border-primary-blue px-2 items-center border-primary-blue">
            <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
              कम्पनीको ठेगाना :
            </label>
            <input
              type="text"
              placeholder=""
              //   name="address"
              {...register("company_address", { required: false })}
              className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
            />
          </div>
        </div>
        <div className="flex-col font-Laila flex md:flex-row flex-wrap">
          <div className="flex flex-1  border-b border-r border-primary-blue items-center m-0 px-2 border-primary-blue">
            <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
              पान नं. ः
            </label>
            <input
              type="text"
              placeholder=" "
              //   name="company_name"
              {...register("pan", { required: false })}
              className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
            />
          </div>
          <div className="flex flex-1 flex-wrap w-fit  border-b  px-2 items-center border-primary-blue">
            <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
              सम्बन्धित ब्यक्तीको नाम
            </label>
            <input
              type="text"
              placeholder=""
              //   name="address"
              {...register("owner_name", { required: false })}
              className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
            />
          </div>
        </div>
        <div className="flex-col font-Laila flex md:flex-row flex-wrap">
          <div className="flex flex-1  md:border-r md:border-b-0 border-b items-center m-0 px-2 border-primary-blue">
            <label className="border-primary-blue flex-shrink-0  text-primary-red  text-lg font-bold">
              सम्बन्धित व्यक्तीको सम्पर्क नं.:
            </label>
            <input
              type="text"
              placeholder=" "
              //   name="company_name"
              {...register("conatact_number", { required: false })}
              className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
            />
          </div>
          <div className="flex flex-1 flex-wrap w-fit   px-2 items-center border-primary-blue">
            <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
              सम्‍बन्धीत व्यक्तीको ठेगाना :
            </label>
            <input
              type="text"
              placeholder=""
              {...register("owner_address", { required: false })}
              className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
            />
          </div>
        </div>
        </div>

        {/* first one clicked */}
        <div className="border-2 bg-pink-100 font-Laila border-primary-blue mt-3">
          <p className="text-primary-blue mt-0 text-lg font-semibold leading-10 text-center">
            घरेलुमा नविकरण सम्बन्धि काम गर्दा शेवा शुल्क वापतको रकम रु.५,०००।–
            मात्र लाग्नेछ ।
          </p>
        </div>
        {/* first one clicked closed*/}

        {/* note */}
        <div className=" border-primary-blue font-Laila mt-3">
          <div className="flex text-primary-blue mt-0 font-semibold leading-10 text-center">
            <span className=" text-primary-red mr-2">नोट :</span> माथी उल्लेखित रकम ७ जना सम्म शेयर सदस्यहरु भएमा मात्र लागु हुनेछ, यदि ७ जना भन्दा बढि भएमा प्रती सदस्य रु.५००।–को दरले थप शुल्क बृद्धि हुदै जानेछ ।
          </div>
        </div>
      </div>
      {/*note closed */}
      {/* new company for 3 months close */}

      <div className=" border-primary-blue my-3">
          <p className=" text-primary-blue font-Calistoga mr-2 text-lg">2. Upload Document
          <span className="text-primary-blue font-Laila">
          (घरेलुमा नविकरण सम्बन्धि काम गर्नको लागि आवश्यक पर्ने निम्न
          कागजपत्रहरु ग्उयिबम गर्नुहोस ।)
          </span>
          </p>
      </div>
      {/* upload documents open */}

      {/* upload documents close */}

      <Documents
        documents_data={upload_document_v2}
        initialState={data_v2}
        setDocument={setDocsOutput}
      />
    <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
              3. Working Branch
              <span className="text-primary-blue font-Laila underline mx-2 ">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>
      <FormBranch register={register}/>

<FormButtom/>
      <NewFormPayment  handleSubmit={handleSubmit} handleClick={handleSub} 
      setUploadProof={setUploadProof}
      />
    </form>
  );
};

export default NewGhaleru;
